/* LastOccurrenceStatusRenderer.js */

"use strict";
const _ = require("lodash");

class LastOccurrenceStatusRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("last-occurrence-status-column");
        this._rootElem.component = this._model;

        this._runningIcon = document.createElement("base-icon-gl");
        this._runningIcon.dataset.icon = "common.loading";
        this._runningIcon.setAttribute("title", "Running");

        this._successIcon = document.createElement("base-icon-gl");
        this._successIcon.dataset.icon = "common.success";
        this._successIcon.setAttribute("title", "Success");

        this._failedIcon = document.createElement("base-icon-gl");
        this._failedIcon.dataset.icon = "common.failed";
        this._failedIcon.setAttribute("title", "Failed");
        this._failedIcon.dataset.invalid = "true";

        this._skippedIcon = document.createElement("base-icon-gl");
        this._skippedIcon.dataset.icon = "common.skipped";
        this._skippedIcon.setAttribute("title", "Skipped");

        this._overlappedIcon = document.createElement("base-icon-gl");
        this._overlappedIcon.dataset.icon = "worktrigger.overlapped";
        this._overlappedIcon.setAttribute("title", "Overlapped");

        this._errorIcon = document.createElement("base-icon-gl");
        this._errorIcon.dataset.icon = "common.error";
        this._errorIcon.setAttribute("title", "Missed");
        this._errorIcon.dataset.invalid = "true";

        this._registerListeners();
        this.render();
    }

    /* ******************************************
    /* START PRIVATE COMPONENT RENDERER METHODS
    /* ****************************************** */
    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();

            this._runningIcon.remove();
            this._runningIcon = undefined;

            this._successIcon.remove();
            this._successIcon = undefined;

            this._failedIcon.remove();
            this._failedIcon = undefined;

            this._skippedIcon.remove();
            this._skippedIcon = undefined;

            this._overlappedIcon.remove();
            this._overlappedIcon = undefined;

            this._errorIcon.remove();
            this._errorIcon = undefined;

            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("LastOccurrenceStatus", (this._onLastOccurrenceStatus = this._onLastOccurrenceStatus.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("LastOccurrenceStatus");
    }

    /* *****************************************
    /* END PRIVATE COMPONENT RENDERER METHODS
    /* START PUBLIC COMPONENT RENDERER METHODS
    /* ***************************************** */
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._setLastOccurrenceStatus(this._model.getLastOccurrenceStatus());
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* *****************************************
    /* END COMPONENT RENDERER METHODS
    /* START HANDLER METHODS
    /* ***************************************** */

    _onLastOccurrenceStatus(newVal) {
        this._setLastOccurrenceStatus(newVal);
    }

    /* *****************************************
    /* END HANDLER METHODS
    /* START PRIVATE API METHODS
    /* ***************************************** */

    _setLastOccurrenceStatus(newVal) {
        this._rootElem.innerHTML = "";
        if (!_.isEmpty(newVal)) {
            switch (newVal) {
                case "RUNNING":
                    this._rootElem.appendChild(this._runningIcon);
                    break;
                case "SUCCESSFUL":
                    this._rootElem.appendChild(this._successIcon);
                    break;
                case "FAILED":
                    this._rootElem.appendChild(this._failedIcon);
                    break;
                case "SKIPPED":
                    this._rootElem.appendChild(this._skippedIcon);
                    break;
                case "OVERLAPPED":
                    this._rootElem.appendChild(this._overlappedIcon);
                    break;
                case "MISSED":
                    this._rootElem.appendChild(this._errorIcon);
                    break;
                default:
                    this._rootElem.innerHTML = newVal;
            }
        } else {
            this._rootElem.innerHTML = "";
        }
    }

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = LastOccurrenceStatusRenderer;
